import ContentContainer from "Components/Container/ContentContainer";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import styles from "./styles/Routes.module.scss";
import { Button, SubTitle } from "Components/CustomComponents";
import { WEB_ROUTES } from "../../constants";
import MapFixed from "Components/Map/MapFixed";
import { useLazyGetRouteDetailsQuery } from "Data/services/routesApi";
import CustomLoader from "Components/CustomComponents/CustomLoader";
import { RouteWithStops } from "Data/interfaces";
import NoDataFound from "Components/CustomComponents/NoDataFound";
import _ from "lodash";

const RouteDetailScreen: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [routeDetails, setRouteDetails] = useState<RouteWithStops | null>(null);
  const { id } = useParams();
  const date = location.state?.selectedDate;
  // console.log(id);

  const [getRouteDetails, { data, isFetching }] = useLazyGetRouteDetailsQuery();
  // console.log(data);

  useEffect(() => {
    getRouteDetails({ id: id, date });
  }, [id, date]);

  useEffect(() => {
    if (data) {
      setRouteDetails(data.data);
    }
  }, [data]);

  return (
    <ContentContainer classes={`${styles.Routes} `} hasBoxShadow={true}>
      <div className="d-flex justify-content-between align-items-center">
        <SubTitle text="Select New Route" classes="mb-2" />
        <div>
          {/* <img alt='' src='../images/calendarIcon.png' width={30} height={30} /> */}
        </div>
      </div>
      {isFetching ? (
        <CustomLoader />

      ) : (
        <section className="my-3">
          <div className="d-flex justify-content-center justify-content-md-between align-items-center flex-wrap gap-4">
            <ContentContainer
              bg="#f5f5f5"
              style={{ width: "400px" }}
              classes="py-3 rounded-4"
            >
              <div className=" d-flex justify-content-between align-items-center">
                <SubTitle text={routeDetails?.route_name} classes="mb-2" />

                <ContentContainer
                  bg="rgba(217, 217, 217, 0.2)"
                  style={{ width: "150px" }}
                  classes="py-2 px-3 rounded-4"
                >
                  <SubTitle
                    text={(routeDetails?.total_stops as unknown as string) || '0'}
                    classes="mb-2"
                  />
                  <p className="fs-6 fw-light gray-text m-0">Total Stops</p>
                </ContentContainer>
              </div>
            </ContentContainer>

            <div>
              {routeDetails?.active_route_id ?
                <Button
                  text={"View Details"}
                  className="px-5 darkBlueBg"
                  onClick={() =>
                    navigate(WEB_ROUTES.ROUTE_TRACKING(routeDetails?.id))
                  }
                />
                :
                <Button
                  text={"Edit Route"}
                  className="px-5 darkBlueBg"
                  onClick={() =>
                    navigate(WEB_ROUTES.EDIT_ROUTE(routeDetails?.id), {
                      state: { routeDetails },
                    })
                  }
                />
              }

            </div>
          </div>
          {_.isEmpty(routeDetails) ?
            <NoDataFound /> :
            <div className="w-100 pt-4">
              <div className={styles.mapContainer}>
                <MapFixed
                  isDirection={true}
                  direction={{
                    origin: {
                      lat: parseFloat(routeDetails.route_stops[0].latitude),
                      lng: parseFloat(routeDetails.route_stops[0].longitude),
                    },
                    destination: {
                      lat: parseFloat(
                        routeDetails.route_stops[
                          routeDetails.route_stops.length - 1
                        ].latitude
                      ),
                      lng: parseFloat(
                        routeDetails.route_stops[
                          routeDetails.route_stops.length - 1
                        ].longitude
                      ),
                    },
                    waypoints: routeDetails.route_stops
                      .slice(1, routeDetails.route_stops.length - 1)
                      ?.map(item => ({ lat: parseFloat(item.latitude), lng: parseFloat(item.longitude) }))
                  }}
                  isGestureHandling={true}
                />
                {/* <img alt='' src='../images/map_detail_route.png' width={"100%"} /> */}
              </div>
            </div>
          }
        </section>
      )}
    </ContentContainer>
  );
};

export default RouteDetailScreen;
